<template>
  <v-app>
    <v-container grid-list-md>
      <v-breadcrumbs
        large
        :items="items"
        divider=">"
      ></v-breadcrumbs>
      <v-flex
        xs10
        offset-xs1
      >
        <blockquote class="blockquote">Clinical trials are studies in which people volunteer to test new treatments, medications or medical devices. Doctors and researchers use clinical trials to determine the safety and effectiveness of new treatments and medications. New treatments must go through clinical trials before being approved by the FDA.
        </blockquote>
        <blockquote class="blockquote">There are many reasons to consider clinical trials. Many people consider clinical trials because they want to help further medical research and to help others. People facing a serious medical condition such as cancer may consider clinical trials so that they can access cutting edge treatment.
        </blockquote>
        <div v-if='user.testResultContent !== undefined'>
          <blockquote class="blockquote font-weight-bold">Based on your <router-link to="healthhistory"> health history</router-link> and <router-link to="genetictesting">genetic test results</router-link>, you may be interested to learn more about the following clinical trials in your area:
          </blockquote>
          <blockquote
            v-if='trialData'
            class="blockquote"
          >This search is based on : {{trialData.query[0]}}
          </blockquote>
          <div
            v-if='!trialData'
            class="text-center"
          >
            <img
              width='196px'
              src='https://firebasestorage.googleapis.com/v0/b/genetic-trust-dev.appspot.com/o/assets%2Fdna.gif?alt=media&token=f3796e1a-0dc4-4815-921b-f67a0295042e'
            />
          </div>
          <v-list
            v-if='trialData'
            three-line
          >

            <v-list-item
              class='ma-3'
              :key='index'
              v-for='(condition,index) in trialData.study'
            >
              <v-list-item-action
                v-if='condition.status[0].$.open === "Y"'
                title='open'
              >
                <v-icon color='green'>add</v-icon>
              </v-list-item-action>
              <v-list-item-action
                v-else
                title='close'
              >
                <v-icon color='red'>remove_circle</v-icon>
              </v-list-item-action>
              <v-list-item-content :title='condition.title[0]'>
                {{condition.title[0]}}
                <v-list-item-sub-title><a
                    target='_blank'
                    :href='condition.url[0]'
                  >{{condition.url[0]}}</a></v-list-item-sub-title>
                <v-list-item-sub-title></v-list-item-sub-title>
              </v-list-item-content>

            </v-list-item>
          </v-list>
        </div>
      </v-flex>
    </v-container>
  </v-app>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
export default {
  computed: {
    ...mapFields([
      'user',
    ]),
  },
  data () {
    return {
      items: [
        {
          text: 'Home',
          disabled: false,
          to: '/home'
        },
        {
          text: 'Clinical Trials',
          disabled: true,

        }],
      trialData: null
    }
  },
  mounted () {
    this.featchXMLtoJSON()
  },
  methods: {
    featchXMLtoJSON () {
      var url = "https://clinicaltrials.gov/ct2/download_fields?cond=Prostate+Cancer+Stage+IV&term=BRCA2&type=&rslt=&recrs=a&age_v=&gndr=&intr=&titles=&outc=&spons=&lead=&id=&cntry=US&state=US%3AWA&city=Olympia&dist=100&locn=&strd_s=&strd_e=&prcd_s=&prcd_e=&sfpd_s=&sfpd_e=&lupd_s=&lupd_e=&sort=&down_fmt=xml"
      this.$axios.get('https://us-central1-genetic-trust-dev.cloudfunctions.net/xml2json', { headers: { 'Content-Type': 'application/json;charset=UTF-8' }, params: { url: url } }
      ).then((response) => {
        this.trialData = response.data.search_results
      })
    },
  }
}
</script>
